import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps } from '@gitbook/spine-react';

import { type UseDeleteSiteItemsProps, useDeleteSiteItems } from './useDeleteSiteItems';

interface DeleteSiteItemsButtonProps
    extends UseDeleteSiteItemsProps,
        Pick<ButtonProps, 'className' | 'label' | 'size'> {
    items: (api.SiteSectionGroup | api.SiteSection | api.SiteSpace)[];
}

export function DeleteSiteItemsButton(props: DeleteSiteItemsButtonProps) {
    const { className, label, size, items } = props;
    const deleteSiteItems = useDeleteSiteItems(props);
    return (
        <Button
            kind="secondary"
            onPress={() => deleteSiteItems(items)}
            leadingIcon={Icon.Trashcan}
            label={label}
            className={className}
            size={size}
        />
    );
}
